// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__58A1O","Title":"style_Title__erO8G"};